export const normalizePhoneInput = (value) => String(value || '').replace(/\D/g, '').slice(0, 10);

export const isValidPhoneNumber = (value) => /^\d{10}$/.test(String(value || '').trim());

export const normalizeEmailInput = (value) => String(value || '').trim().toLowerCase();

export const isValidEmail = (value) => {
  const email = normalizeEmailInput(value);
  if (!email) return true;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

